const languageAllow = ['markup', 'javascript', 'json', 'css',  'c#', 'yaml', 'python', 'java', 'cpp', 'go'];

/*
   v1接口拉老文档，代码片断格式
*/
export const handleCode = (html) => {
  let result = html;
  const codeList = html.match(/<ac:structured-macro.*?ac:structured-macro>/gms) || [];

  codeList.forEach((codeItem) => {
    let codeTemp = codeItem;
    let language = 'javascript';


    /*
      代码标签
      <ac:structured-macro>...</ac:structured-macro>
    */
    codeTemp = codeTemp.replace(/<ac:structured-macro/gms, '<div class="code"');
    codeTemp = codeTemp.replace(/\/ac:structured-macro>/gms, '/div>');

    /*
        代码文本
        <ac:plain-text-body>...</ac:plain-text-body>
    */
    codeTemp = codeTemp.replace(/<ac:plain-text-body>/gms, '<pre>');
    codeTemp = codeTemp.replace(/<\/ac:plain-text-body>/gms, '</pre>');

    /*
        代码参数标识，只要取出language，其它都可以过滤掉
        <ac:parameter ac:name="language">js</ac:parameter>
        <ac:parameter ac:name="theme">RDark</ac:parameter>
        <ac:parameter ac:name="firstline">13</ac:parameter>
        <ac:parameter ac:name="title">test</ac:parameter>
        <ac:parameter ac:name="linenumbers">true</ac:parameter>
        <ac:parameter ac:name="collapse">true</ac:parameter>
    */
    const languageTag = codeTemp.match(/<ac:parameter\sac:name=\"language\">(.*?)<\/ac:parameter>/gms);
    if (languageTag && languageTag.length > 0) {
      let languageFromTag = languageTag[0].replace(
        /<ac:parameter\sac:name=\"language\">(.*?)<\/ac:parameter>/gms,
        '$1',
      );
      languageFromTag = languageFromTag.replace(/js$/, 'javascript');
      languageFromTag = languageFromTag.replace(/xml$/, 'markup');
      languageFromTag = languageFromTag.replace(/py$/, 'python');
      if (languageAllow.includes(languageFromTag)) {
        language = languageFromTag;
      }
    }

    codeTemp = codeTemp.replace(/<ac:parameter\sac:name=\"language\">.*?<\/ac:parameter>/gms, '');
    codeTemp = codeTemp.replace(/<ac:parameter\sac:name=\"theme\">.*?<\/ac:parameter>/gms, '');
    codeTemp = codeTemp.replace(/<ac:parameter\sac:name=\"firstline\">.*?<\/ac:parameter>/gms, '');
    codeTemp = codeTemp.replace(/<ac:parameter\sac:name=\"title\">.*?<\/ac:parameter>/gms, '');
    codeTemp = codeTemp.replace(/<ac:parameter\sac:name=\"linenumbers\">.*?<\/ac:parameter>/gms, '');
    codeTemp = codeTemp.replace(/<ac:parameter\sac:name=\"collapse\">.*?<\/ac:parameter>/gms, '');


    /*
      取出代码文本，代码文本会被CDATA包一下
      <![CDATA[...]]>
    */
    let codeContent = '';
    const cdataTag = codeTemp.match(/<!\[CDATA\[(.*?)]]/gms);
    if (cdataTag && cdataTag.length > 0) {
      codeContent = cdataTag[0].replace(
        /<!\[CDATA\[(.*?)]]/gms,
        '$1',
      );
    }

    /*
      替换代码文本中如html标签的尖括号
      因为v-html会转义一次，这里要转义2次，才能交给prism展示
      <  ->   &lt;  ->  &amp;lt;
    */
    codeContent = codeContent.replace(/</gms, '&amp;lt;');

    codeTemp = codeTemp.replace(
      /<!\[CDATA\[(.*?)]]>/gms,
      `<code class=\"language-${language} line-numbers\">${codeContent}</code>`,
    );

    result = result.replace(codeItem, codeTemp);
  });

  return result;
};
